export interface Translations {
  appTitle: string;
  appSubtitle: string;
  home: string;
  catalog: string;
  heroDescription: string;
  heroTitle: string;
  exploreCatalog: string;
  featuredTravels: string;
  featuredSubtitle: string;
  ourProposals: string;
  ourProposalsSubtitle: string;
  specialOffers: string;
  specialOffersSubtitle: string;
  viewAllTravels: string;
  viewAllSpecialOffers: string;
  travelCategories: string;
  navbar: {
    home: string;
    whoWeAre: string;
    ourTravels: string;
    joinClub: string;
    contacts: string;
    admin: string;
    login: string;
    logout: string;
    contactLabel: string;
    contactUs: string;
  };
  breadcrumbs: {
    catalog: string;
    filteredCatalog: string;
    gallery: string;
    about: string;
    contact: string;
    joinClub: string;
    travelDetails: string;
    individualTravelDetails: string;
    admin: string;
    addTravel: string;
    editTravel: string;
    addIndividualTravel: string;
    editIndividualTravel: string;
    users: string;
    settings: string;
  };
  categories: {
    singleDay: string;
    multiDay: string;
    concerts: string;
    cruise: string;
    seaside: string;
    cigliaTours: string;
  };
  stats: {
    travelersLabel: string;
    confirmedTripsLabel: string;
    destinationsLabel: string;
  };
  photoGalleryTitle: string;
  viewGalleryButton: string;
  noGalleryImages: string;
  explorePackages: string;
  travelCount: {
    singular: string;
    plural: string;
  };
  destination: string;
  allDestinations: string;
  category: string;
  allCategories: string;
  specialCategoryDescription: string;
  duration: string;
  allDurations: string;
  durationRanges: {
    "1": string;
    "2+": string;
    "5-7": string;
    "8+": string;
  };
  clearFilters: string;
  searchKeyword: string;
  searchPlaceholder: string;
  days: string;
  day: string;
  startLabel: string;
  endLabel: string;
  from: string;
  to: string;
  bookNow: string;
  viewDetails: string;
  backToCatalog: string;
  maxPeople: string;
  years: string;
  overview: string;
  individualTravel: string;
  perPerson: string;
  startingFrom: string;
  singleSupplement: string;
  downloadProgram: string;
  highlights: string;
  itinerary: string;
  dayLabel: string;
  extraInfo: string;
  included: string;
  notIncluded: string;
  faq: string;
  readyToBook: string;
  contactUs: string;
  similarTravels: string;
  noResultsTitle: string;
  noResultsIndividualTitle: string;
  noResultsSpecialTitle: string;
  noResultsText: string;
  noResultsEncouragement: string;
  noResultsIndividualEncouragement: string;
  noResultsSpecialEncouragement: string;
  noResultsContact1: string;
  noResultsContact2: string;
  footerText: string;
  footer: {
    offices: string;
    hours: string;
    contacts: string;
    followUs: string;
    email: string;
    mondayFriday: string;
    saturday: string;
    agencyHours: string;
    termsAndConditions: string;
  };
  about: {
    title: string;
    heroSubtitle: string;
    teamTitle: string;
    teamText1: string;
    teamText2: string;
    teamText3: string;
    cigliaToursBrandTitle: string;
    cigliaToursBrandText1: string;
    cigliaToursBrandText2: string;
    cigliaToursBrandText3: string;
    cigliaToursBrandText4: string;
    cigliaToursBrandText5: string;
    cigliaToursBrandText6: string;
    missionTitle: string;
    missionText: string;
    valuesTitle: string;
    value1Title: string;
    value1Text: string;
    value2Title: string;
    value2Text: string;
    value3Title: string;
    value3Text: string;
    closingTitle: string;
    closingSignature: string;
  };
  contact: {
    title: string;
    nameLabel: string;
    namePlaceholder: string;
    emailLabel: string;
    emailPlaceholder: string;
    messageLabel: string;
    messagePlaceholder: string;
    privacyText: string;
    privacyPolicy: string;
    privacyRequired: string;
    send: string;
    sending: string;
    successMessage: string;
    officesTitle: string;
    hours: string;
    emailTitle: string;
    companyInfo: string;
    viewDirections: string;
  };
  joinClub: {
    title: string;
    greeting: string;
    introText: string;
    channelDescription: string;
    contactText: string;
    howToTitle: string;
    step1: string;
    step2: string;
    step3: string;
    step4: string;
    step5: string;
    channelLink: string;
    benefitTitle: string;
    benefitText: string;
    ctaTitle: string;
    joinButton: string;
  };
  difficulty: {
    Easy: string;
    Moderate: string;
    Challenging: string;
  };
  status: {
    confirmed: string;
    available: string;
    soldOut: string;
  };
  login: {
    title: string;
    subtitle: string;
    username: string;
    password: string;
    signIn: string;
    signingIn: string;
    invalidCredentials: string;
    demoCredentials: string;
    backToHome: string;
    enterUsername: string;
    enterPassword: string;
  };
  destinations: {
    [key: string]: string;
  };
  descriptions: {
    [key: number]: string;
  };
  loading: string;
}

export const translations: Record<string, Translations> = {
  en: {
    // Header
    appTitle: "StradaFacendo.club",
    appSubtitle: "Discover your next adventure",
    home: "Home",
    catalog: "Catalog",

    // Home Page
    heroTitle: "Life is now. Leave and discover the world with us",
    heroDescription:
      "Explore the world's most amazing destinations with our carefully curated travels. Your dream vacation awaits!",
    exploreCatalog: "Explore Catalog",
    navbar: {
      home: "Home",
      whoWeAre: "About Us",
      ourTravels: "Our Travels",
      joinClub: "Join the Club",
      contacts: "Contacts",
      admin: "Admin",
      login: "Login",
      logout: "Logout",
      contactLabel: "Contact us on WhatsApp at",
      contactUs: "Contact us",
    },
    breadcrumbs: {
      catalog: "Catalog",
      filteredCatalog: "Filtered Catalog",
      gallery: "Gallery",
      about: "About Us",
      contact: "Contacts",
      joinClub: "Join the Club",
      travelDetails: "Travel Details",
      individualTravelDetails: "Individual Travel Details",
      admin: "Admin Dashboard",
      addTravel: "Add Travel",
      editTravel: "Edit Travel",
      addIndividualTravel: "Add Individual Travel",
      editIndividualTravel: "Edit Individual Travel",
      users: "Users",
      settings: "Settings",
    },
    featuredTravels: "Featured Travels",
    featuredSubtitle: "Handpicked destinations for unforgettable experiences",
    ourProposals: "Weekend Proposals",
    ourProposalsSubtitle: "Last-minute available spots for weekend trips",
    specialOffers: "Holiday Offers Cigliantours",
    specialOffersSubtitle:
      "Exclusive individual departure trips selected for you",
    viewAllTravels: "View All Travels",
    viewAllSpecialOffers: "View All Holiday Offers",
    travelCategories: "Browse by Category",
    categories: {
      singleDay: "Day Trips",
      multiDay: "Multi-Day Travels",
      concerts: "Concerts & Shows",
      cruise: "Cruises",
      seaside: "Seaside Stay",
      cigliaTours: "Holiday Offers",
    },
    stats: {
      travelersLabel: "Travelers who chose us",
      confirmedTripsLabel: "Confirmed trips",
      destinationsLabel: "Destinations every year",
    },
    photoGalleryTitle: "Our Photos",
    viewGalleryButton: "View Photo Gallery",
    noGalleryImages: "No images available at the moment",

    // Filter Bar
    explorePackages: "Explore Our Travels",
    travelCount: {
      singular: "travel available",
      plural: "travels available",
    },
    destination: "Destination",
    allDestinations: "All Destinations",
    category: "Category",
    allCategories: "All Categories",
    specialCategoryDescription:
      "Individual departures for those who love to travel independently",
    duration: "Duration",
    allDurations: "All Durations",
    durationRanges: {
      "1": "1 day",
      "2+": "2+ days",
      "5-7": "5-7 days",
      "8+": "8+ days",
    },
    clearFilters: "Clear Filters",
    searchKeyword: "Search",
    searchPlaceholder:
      "Search a destination or type of travel you'd like to take...",

    // Travel Card
    days: "days",
    day: "day",
    startLabel: "Start:",
    endLabel: "End:",
    from: "From",
    to: "to",
    bookNow: "Book Now",
    viewDetails: "View Details",
    backToCatalog: "Back to Catalog",
    maxPeople: "max people",
    years: "years",
    overview: "Overview",
    individualTravel: "Individual Travel",
    perPerson: "per person",
    startingFrom: "Starting from",
    singleSupplement: "single supplement",
    downloadProgram: "Download Program",
    highlights: "Highlights",
    itinerary: "Itinerary",
    dayLabel: "Day",
    extraInfo: "Additional Information",
    included: "What's Included",
    notIncluded: "What's Not Included",
    faq: "Frequently Asked Questions",
    readyToBook: "Ready to book your adventure?",
    contactUs: "Contact us to reserve your spot on this amazing journey!",
    similarTravels: "You Might Also Like",

    // No Results
    noResultsTitle: "No group trips currently available",
    noResultsIndividualTitle: "No individual trips currently available",
    noResultsSpecialTitle: "No special offers currently available",
    noResultsText:
      "😞 But don't worry! We can create a custom quote just for you 😊",
    noResultsEncouragement:
      "But don't worry! We can create a custom quote just for you",
    noResultsIndividualEncouragement:
      "But don't worry! We can organize an individual trip tailored to your needs",
    noResultsSpecialEncouragement:
      "But don't worry! We can find the best special offer for your next trip",
    noResultsContact1: "Write to us on WhatsApp at",
    noResultsContact2: "or call us at",

    // Footer
    footerText: "© 2024 Wanderlust Travel Agency. All rights reserved.",
    footer: {
      offices: "Our Offices",
      hours: "Opening Hours",
      contacts: "Contacts",
      followUs: "Follow Us",
      email: "Email",
      mondayFriday: "Monday to Friday",
      saturday: "Saturday",
      agencyHours: "Check with agency",
      termsAndConditions: "Terms and Conditions",
    },

    // About Page
    about: {
      title: "About Us",
      heroSubtitle: "Creating a journey, we make a dream come true!",
      teamTitle: "Our Team",
      teamText1:
        "We are an all-female team and we decided to combine our experience in the tourism field.",
      teamText2:
        "Inheriting a historic agency in Cigliano, we accepted a challenge and took on a responsibility: the challenge is to bring professionalism and innovation to a sector that always needs novelty.",
      teamText3:
        "The responsibility is to do our best to satisfy our customers and always bring new ones.",
      cigliaToursBrandTitle: "CiglianTours & StradaFacendo",
      cigliaToursBrandText1:
        "We are a full-service travel agency, handling all destinations, cruises, dream vacations, and most importantly, group trips!",
      cigliaToursBrandText2:
        "Why group trips? Because discovering the world together is the best way to travel. No worries about bookings, parking, language, and documents: we take care of everything!",
      cigliaToursBrandText3:
        "Cigliantours is the name of our agency that prepares the perfect vacation package tailored to your personality, exclusively for you.",
      cigliaToursBrandText4:
        "StradaFacendo is the brand that creates group trips and gets you traveling comfortably, stress-free but with lots of fun.",
      cigliaToursBrandText5:
        "Pack your backpack and come visit us at our offices in Cigliano, Santhià, and Vercelli... or write to us comfortably from home via WhatsApp.",
      cigliaToursBrandText6: "We are already ready to leave, and you?",
      missionTitle: "Our Mission",
      missionText:
        "We are committed to creating unforgettable travel experiences, combining tradition with innovation. Every journey we organize is designed to exceed expectations and create lasting memories.",
      valuesTitle: "Our Values",
      value1Title: "Professionalism",
      value1Text:
        "We bring years of experience and dedication to every travel arrangement, ensuring the highest quality service.",
      value2Title: "Innovation",
      value2Text:
        "We constantly seek new destinations and experiences to offer our customers unique and exciting journeys.",
      value3Title: "Customer Care",
      value3Text:
        "Your satisfaction is our priority. We work tirelessly to ensure every detail of your trip is perfect.",
      closingTitle: "With You, Always!",
      closingSignature: "The Travelers' Club, StradaFacendo",
    },

    // Contact Page
    contact: {
      title: "Contacts",
      nameLabel: "Your Name and Surname",
      namePlaceholder: "Enter your full name",
      emailLabel: "Your Email",
      emailPlaceholder: "Enter your email address",
      messageLabel: "Your Message",
      messagePlaceholder: "Tell us how we can help you...",
      privacyText:
        "I declare that I accept the use of my data to be contacted by StradaFacendo by Cigliantours. Data will be processed according to current legislation and the",
      privacyPolicy: "privacy policy",
      privacyRequired: "You must accept the privacy policy to send the message",
      send: "Send",
      sending: "Sending...",
      successMessage: "Thank you for your message! We will contact you soon.",
      officesTitle: "Our Offices",
      hours: "Hours",
      emailTitle: "Email",
      companyInfo: "Company Information",
      viewDirections: "Click on the office pins below to get directions",
    },

    // Join Club Page
    joinClub: {
      title: "Join the Club",
      greeting: "Hello Travelers!",
      introText:
        "From today, to receive our travel posters, we created a new method: the WhatsApp Channel!",
      channelDescription:
        "The Channel is similar to a 'group' but to be used exclusively to view all the posters with details of our travels.",
      contactText:
        "You cannot contact us directly in the channel. To write to us, you can continue to use our traditional WhatsApp Chat at the usual number",
      howToTitle: "How to Join the StradaFacendo WhatsApp Channel?",
      step1: "Click the following link:",
      step2: "Press 'Accept and Continue'",
      step3:
        "Once inside the channel, press the button at the bottom and click FOLLOW THE CHANNEL",
      step4:
        "Every time a new update is published, you will receive a notification and by entering the channel, you can see the trip!",
      step5:
        "The channel is visible in the UPDATES section (the button is at the bottom of WhatsApp), under CHANNELS.",
      channelLink: "STRADAFACENDO WHATSAPP CHANNEL",
      benefitTitle: "Remember to Turn On Notifications!",
      benefitText:
        "Just click on the bell next to the subscribe button to never miss our travel updates!",
      ctaTitle: "Ready to Join?",
      joinButton: "Join WhatsApp Channel",
    },

    // Difficulty levels
    difficulty: {
      Easy: "Easy",
      Moderate: "Moderate",
      Challenging: "Challenging",
    },

    // Travel status
    status: {
      confirmed: "Confirmed",
      available: "Last Available",
      soldOut: "Sold Out",
    },

    // Login Page
    login: {
      title: "Admin Login",
      subtitle: "Sign in to access admin features",
      username: "Username",
      password: "Password",
      signIn: "Sign In",
      signingIn: "Signing in...",
      invalidCredentials: "Invalid username or password",
      demoCredentials: "Demo credentials:",
      backToHome: "Back to Home",
      enterUsername: "Enter username",
      enterPassword: "Enter password",
    },

    // Destinations
    destinations: {
      "Paris, France": "Paris, France",
      "Tokyo, Japan": "Tokyo, Japan",
      "Santorini, Greece": "Santorini, Greece",
      "New York, USA": "New York, USA",
      "Bali, Indonesia": "Bali, Indonesia",
      "Rome, Italy": "Rome, Italy",
      "Dubai, UAE": "Dubai, UAE",
      "Barcelona, Spain": "Barcelona, Spain",
      Iceland: "Iceland",
      Maldives: "Maldives",
      "Sydney, Australia": "Sydney, Australia",
      "Machu Picchu, Peru": "Machu Picchu, Peru",
      "Venice, Italy": "Venice, Italy",
      "Cinque Terre, Italy": "Cinque Terre, Italy",
      "Florence, Italy": "Florence, Italy",
    },

    // Travel Descriptions
    descriptions: {
      1: "Experience the magic of Paris with visits to the Eiffel Tower, Louvre Museum, and charming cafés along the Seine. Discover the city of lights and romance.",
      2: "Immerse yourself in the perfect blend of ancient traditions and modern innovation. Visit temples, enjoy authentic sushi, and explore bustling Tokyo streets.",
      3: "Relax in the stunning white-washed villages overlooking the azure Aegean Sea. Enjoy spectacular sunsets, local cuisine, and crystal-clear beaches.",
      4: "Explore the city that never sleeps! Visit Times Square, Central Park, Statue of Liberty, and enjoy world-class museums and Broadway shows.",
      5: "Discover tropical paradise with lush rice terraces, ancient temples, pristine beaches, and warm Balinese hospitality. Perfect for relaxation and adventure.",
      6: "Walk through history in the Eternal City. Explore the Colosseum, Vatican, Trevi Fountain, and indulge in authentic Italian cuisine and gelato.",
      7: "Experience luxury and innovation in this futuristic desert oasis. Visit Burj Khalifa, enjoy desert safaris, and shop in world-class malls.",
      8: "Explore Gaudí's architectural masterpieces, stroll Las Ramblas, relax on Mediterranean beaches, and savor delicious tapas and paella.",
      9: "Witness the land of fire and ice with spectacular waterfalls, geysers, Northern Lights, and geothermal hot springs. A nature lover's dream.",
      10: "Escape to paradise with overwater bungalows, crystal-clear turquoise waters, vibrant coral reefs, and ultimate relaxation on pristine white beaches.",
      11: "Experience the iconic Sydney Opera House, beautiful harbors, stunning beaches, and unique wildlife. Explore the vibrant culture of Down Under.",
      12: "Trek to the ancient Incan citadel high in the Andes Mountains. Discover rich history, breathtaking mountain views, and vibrant Peruvian culture.",
      13: "Day trip to discover the romantic canals of Venice. Visit St. Mark's Basilica, enjoy a gondola ride, and explore the charming streets of this unique floating city.",
      14: "One-day tour of the stunning Cinque Terre coastline. Hike between colorful villages perched on cliffs, enjoy local seafood, and take in breathtaking Mediterranean views.",
      15: "Day trip to the Renaissance capital. Marvel at the Duomo, explore the Uffizi Gallery, and walk across the iconic Ponte Vecchio while discovering Tuscan art and culture.",
    },
    loading: "Loading...",
  },
  it: {
    // Header
    appTitle: "StradaFacendo.club",
    appSubtitle: "Scopri la tua prossima avventura",
    home: "Home",
    catalog: "Catalogo",

    // Home Page
    heroTitle: "La vita è adesso. Parti e scopri il mondo con noi",
    heroDescription:
      "Esplora le destinazioni più sorprendenti del mondo con i nostri viaggi selezionati con cura. La tua vacanza da sogno ti aspetta!",
    exploreCatalog: "Esplora il Catalogo",
    navbar: {
      home: "Home",
      whoWeAre: "Chi Siamo",
      ourTravels: "I Nostri Viaggi",
      joinClub: "Entra nel Club",
      contacts: "Contatti",
      admin: "Admin",
      login: "Login",
      logout: "Logout",
      contactLabel: "Contattaci su WhatsApp al numero",
      contactUs: "Contattaci",
    },
    breadcrumbs: {
      catalog: "Catalogo",
      filteredCatalog: "Catalogo Filtrato",
      gallery: "Galleria",
      about: "Chi Siamo",
      contact: "Contatti",
      joinClub: "Entra nel Club",
      travelDetails: "Dettaglio Viaggio",
      individualTravelDetails: "Dettaglio Viaggio Individuale",
      admin: "Dashboard Admin",
      addTravel: "Aggiungi Viaggio",
      editTravel: "Modifica Viaggio",
      addIndividualTravel: "Aggiungi Viaggio Individuale",
      editIndividualTravel: "Modifica Viaggio Individuale",
      users: "Utenti",
      settings: "Impostazioni",
    },
    featuredTravels: "Viaggi in Evidenza",
    featuredSubtitle: "Destinazioni selezionate per esperienze indimenticabili",
    ourProposals: "Proposte per il weekend",
    ourProposalsSubtitle: "Ultimi posti disponibili per viaggi last minute",
    specialOffers: "Grandi Viaggi e Mete da sogno",
    specialOffersSubtitle: "Partenze individuali esclusive selezionate per te",
    viewAllTravels: "Vedi Tutti i Viaggi",
    viewAllSpecialOffers: "Vedi Tutti i Grandi Viaggi",
    travelCategories: "Esplora per Categoria",
    categories: {
      singleDay: "Viaggi di Gruppo in Giornata",
      multiDay: "Viaggi di Gruppo di Più Giorni",
      concerts: "Concerti e Spettacoli",
      cruise: "Crociere",
      seaside: "Soggiorni Mare",
      cigliaTours: "Grandi Viaggi",
    },
    stats: {
      travelersLabel: "Viaggiatori che ci hanno scelto",
      confirmedTripsLabel: "Viaggi confermati",
      destinationsLabel: "Destinazioni ogni anno",
    },
    photoGalleryTitle: "Le nostre foto",
    viewGalleryButton: "Vedi Galleria Fotografica",
    noGalleryImages: "Nessuna immagine disponibile al momento",

    // Filter Bar
    explorePackages: "Esplora i Nostri Viaggi",
    travelCount: {
      singular: "viaggio disponibile",
      plural: "viaggi disponibili",
    },
    destination: "Destinazione",
    allDestinations: "Tutte le Destinazioni",
    category: "Categoria",
    allCategories: "Tutte le Categorie",
    specialCategoryDescription: "Destinazioni pensate per chi ama il mondo",
    duration: "Durata",
    allDurations: "Tutte le Durate",
    durationRanges: {
      "1": "1 giorno",
      "2+": "2+ giorni",
      "5-7": "5-7 giorni",
      "8+": "8+ giorni",
    },
    clearFilters: "Cancella Filtri",
    searchKeyword: "Cerca",
    searchPlaceholder:
      "Scrivi una destinazione o un tipo di viaggio che vorresti fare...",

    // Travel Card
    days: "giorni",
    day: "giorno",
    startLabel: "Inizio:",
    endLabel: "Fine:",
    from: "Da",
    to: "a",
    bookNow: "Prenota Ora",
    viewDetails: "Vedi Dettagli",
    backToCatalog: "Torna al Catalogo",
    maxPeople: "persone max",
    years: "anni",
    overview: "Panoramica",
    individualTravel: "Viaggio Individuale",
    perPerson: "a persona",
    startingFrom: "A partire da",
    singleSupplement: "supplemento singola",
    downloadProgram: "Scarica Programma",
    highlights: "Punti Salienti",
    itinerary: "Itinerario",
    dayLabel: "Giorno",
    extraInfo: "Informazioni Aggiuntive",
    included: "Cosa è Incluso",
    notIncluded: "Cosa Non è Incluso",
    faq: "Domande Frequenti",
    readyToBook: "Pronto a prenotare la tua avventura?",
    contactUs:
      "Contattaci per riservare il tuo posto in questo fantastico viaggio!",
    similarTravels: "Potrebbero Interessarti Anche",

    // No Results
    noResultsTitle: "Nessun viaggio di gruppo al momento disponibile",
    noResultsIndividualTitle:
      "Nessun viaggio individuale al momento disponibile",
    noResultsSpecialTitle: "Nessuna offerta vacanze al momento disponibile",
    noResultsText:
      "😞 Ma non preoccuparti! Possiamo costruire un preventivo apposta per te 😊",
    noResultsEncouragement:
      "Ma non preoccuparti! Possiamo costruire un preventivo apposta per te",
    noResultsIndividualEncouragement:
      "😞 Ma non preoccuparti! Possiamo organizzare un viaggio individuale su misura per te 😊",
    noResultsSpecialEncouragement:
      "Ma non preoccuparti! Possiamo trovare l'offerta vacanze migliore per il tuo prossimo viaggio",
    noResultsContact1: "Scrivici su WhatsApp al numero",
    noResultsContact2: "oppure chiamaci al",

    // Footer
    footerText: "© 2024 StradaFacendo.club. Tutti i diritti riservati.",
    footer: {
      offices: "Le Nostre Sedi",
      hours: "Orari di Apertura",
      contacts: "Contatti",
      followUs: "Seguici",
      email: "Email",
      mondayFriday: "Dal Lunedì al Venerdì",
      saturday: "Sabato",
      agencyHours: "Orari d'Agenzia",
      termsAndConditions: "Condizioni Generali",
    },

    // About Page
    about: {
      title: "Chi Siamo",
      heroSubtitle: "Creando un viaggio realizziamo un sogno!",
      teamTitle: "Il Nostro Team",
      teamText1:
        "Siamo un team tutto al femminile e abbiamo deciso di mettere insieme le nostre esperienze nel campo del turismo.",
      teamText2:
        "Ereditando un'agenzia storica di Cigliano, abbiamo accettato una sfida e abbiamo preso una responsabilità: la sfida è quella di portare professionalità ed innovazione in un settore che ha sempre bisogno di novità.",
      teamText3:
        "La responsabilità è quella di fare del nostro meglio per soddisfare i nostri clienti e portarne sempre di nuovi.",
      cigliaToursBrandTitle: "CiglianTours & StradaFacendo",
      cigliaToursBrandText1:
        "Siamo un'agenzia viaggi a 360 gradi, che si occupa di tutte le destinazioni, di crociere, di vacanze da sogno e, soprattutto, di viaggi di gruppo!",
      cigliaToursBrandText2:
        "Perché i viaggi di gruppo? Perché scoprire il mondo insieme è il miglior modo di viaggiare. Zero pensieri su prenotazioni, parcheggi, lingua e documenti: pensiamo noi a tutto!",
      cigliaToursBrandText3:
        "Cigliantours è il nome della nostra agenzia che prepara il pacchetto vacanze adatto alla tua personalità, in esclusiva per te",
      cigliaToursBrandText4:
        "StradaFacendo è il brand che crea il viaggio di gruppo e ti fa partire in tutta comodità, senza stress ma con tanto divertimento.",
      cigliaToursBrandText5:
        "Prepara lo zaino e vieni a trovarci nelle nostre sedi di Cigliano, Santhià e Vercelli.. oppure scrivici comodamente da casa via WhatsApp",
      cigliaToursBrandText6: "Noi siamo già pronti a partire, e tu?",
      missionTitle: "La Nostra Missione",
      missionText:
        "Ci impegniamo a creare esperienze di viaggio indimenticabili, combinando tradizione e innovazione. Ogni viaggio che organizziamo è pensato per superare le aspettative e creare ricordi duraturi.",
      valuesTitle: "I Nostri Valori",
      value1Title: "Professionalità",
      value1Text:
        "Portiamo anni di esperienza e dedizione in ogni organizzazione di viaggio, garantendo un servizio di alta qualità.",
      value2Title: "Innovazione",
      value2Text:
        "Cerchiamo costantemente nuove destinazioni ed esperienze per offrire ai nostri clienti viaggi unici ed emozionanti.",
      value3Title: "Cura del Cliente",
      value3Text:
        "La vostra soddisfazione è la nostra priorità. Lavoriamo instancabilmente per assicurarci che ogni dettaglio del vostro viaggio sia perfetto.",
      closingTitle: "Noi con Voi, sempre!",
      closingSignature: "Il Club dei viaggiatori, StradaFacendo",
    },

    // Contact Page
    contact: {
      title: "Contatti",
      nameLabel: "Il tuo Nome e Cognome",
      namePlaceholder: "Inserisci il tuo nome completo",
      emailLabel: "La tua E-mail",
      emailPlaceholder: "Inserisci il tuo indirizzo email",
      messageLabel: "Il tuo Messaggio",
      messagePlaceholder: "Raccontaci come possiamo aiutarti...",
      privacyText:
        "Dichiaro di accettare l'utilizzo dei miei dati al fine di essere ricontattato da StradaFacendo by Cigliantours. I dati verranno trattati secondo la normativa vigente e la",
      privacyPolicy: "privacy policy",
      privacyRequired:
        "Devi accettare la privacy policy per inviare il messaggio",
      send: "Invia",
      sending: "Invio in corso...",
      successMessage: "Grazie per il tuo messaggio! Ti contatteremo presto.",
      officesTitle: "Le Nostre Sedi",
      hours: "Orari",
      emailTitle: "Email",
      viewDirections:
        "Clicca sui pin delle sedi qui sotto per ottenere indicazioni",
      companyInfo: "Informazioni Aziendali",
    },

    // Join Club Page
    joinClub: {
      title: "Entra nel Club",
      greeting: "Buongiorno Viaggiatori!",
      introText:
        "Da oggi, per ricevere i nostri manifesti di viaggio, abbiamo creato un nuovo metodo: il Canale WhatsApp!",
      channelDescription:
        "Il Canale è simile ad un 'gruppo' ma da utilizzare esclusivamente per visualizzare tutti i manifesti con dettagli dei nostri viaggi.",
      contactText:
        "Nel canale non puoi contattarci direttamente. Per scriverci puoi continuare ad utilizzare la nostra tradizionale Chat WhatsApp al solito numero",
      howToTitle: "Come iscriversi al Canale WhatsApp Stradafacendo?",
      step1: "Clicca sul seguente link:",
      step2: "Premi 'Accetta e Continua'",
      step3:
        "Una volta dentro al canale, premi sul pulsante in basso e clicca su SEGUI IL CANALE",
      step4:
        "Ogni volta che verrà pubblicato un nuovo aggiornamento, ti arriverà una notifica e entrando nel canale, potrai vedere il viaggio!",
      step5:
        "Il canale è visibile nella sezione AGGIORNAMENTI (il pulsante si trova in basso su WhatsApp), alla voce CANALI.",
      channelLink: "CANALE WHATSAPP STRADAFACENDO",
      benefitTitle: "Ricordati di Attivare le Notifiche!",
      benefitText:
        "Basta cliccare sulla campanella accanto al pulsante iscriviti per non perdere mai i nostri aggiornamenti di viaggio!",
      ctaTitle: "Pronto per Entrare?",
      joinButton: "Entra nel Canale WhatsApp",
    },

    // Difficulty levels
    difficulty: {
      Easy: "Facile",
      Moderate: "Moderato",
      Challenging: "Impegnativo",
    },

    // Travel status
    status: {
      confirmed: "Confermato",
      available: "Ultimi Posti",
      soldOut: "Sold Out",
    },

    // Login Page
    login: {
      title: "Login Amministratore",
      subtitle: "Accedi per utilizzare le funzioni amministrative",
      username: "Nome utente",
      password: "Password",
      signIn: "Accedi",
      signingIn: "Accesso in corso...",
      invalidCredentials: "Nome utente o password non validi",
      demoCredentials: "Credenziali demo:",
      backToHome: "Torna alla Home",
      enterUsername: "Inserisci nome utente",
      enterPassword: "Inserisci password",
    },

    // Destinations
    destinations: {
      "Paris, France": "Parigi, Francia",
      "Tokyo, Japan": "Tokyo, Giappone",
      "Santorini, Greece": "Santorini, Grecia",
      "New York, USA": "New York, USA",
      "Bali, Indonesia": "Bali, Indonesia",
      "Rome, Italy": "Roma, Italia",
      "Dubai, UAE": "Dubai, EAU",
      "Barcelona, Spain": "Barcellona, Spagna",
      Iceland: "Islanda",
      Maldives: "Maldive",
      "Sydney, Australia": "Sydney, Australia",
      "Machu Picchu, Peru": "Machu Picchu, Perù",
      "Venice, Italy": "Venezia, Italia",
      "Cinque Terre, Italy": "Cinque Terre, Italia",
      "Florence, Italy": "Firenze, Italia",
    },

    // Travel Descriptions
    descriptions: {
      1: "Vivi la magia di Parigi con visite alla Torre Eiffel, al Museo del Louvre e agli affascinanti caffè lungo la Senna. Scopri la città delle luci e del romanticismo.",
      2: "Immergiti nella perfetta fusione di antiche tradizioni e innovazione moderna. Visita i templi, gusta il sushi autentico ed esplora le vivaci strade di Tokyo.",
      3: "Rilassati negli splendidi villaggi dalle case bianche che si affacciano sul Mar Egeo azzurro. Goditi tramonti spettacolari, cucina locale e spiagge cristalline.",
      4: "Esplora la città che non dorme mai! Visita Times Square, Central Park, la Statua della Libertà e goditi musei di livello mondiale e spettacoli di Broadway.",
      5: "Scopri il paradiso tropicale con rigogliose risaie a terrazza, antichi templi, spiagge incontaminate e la calda ospitalità balinese. Perfetto per relax e avventura.",
      6: "Cammina attraverso la storia nella Città Eterna. Esplora il Colosseo, il Vaticano, la Fontana di Trevi e concediti l'autentica cucina italiana e il gelato.",
      7: "Vivi il lusso e l'innovazione in questa oasi futuristica nel deserto. Visita il Burj Khalifa, goditi safari nel deserto e fai shopping nei centri commerciali di classe mondiale.",
      8: "Esplora i capolavori architettonici di Gaudí, passeggia per Las Ramblas, rilassati sulle spiagge mediterranee e assapora deliziose tapas e paella.",
      9: "Ammira la terra di fuoco e ghiaccio con spettacolari cascate, geyser, aurore boreali e sorgenti termali geotermiche. Il sogno di un amante della natura.",
      10: "Fuggi in paradiso con bungalow sull'acqua, acque turchesi cristalline, barriere coralline vibranti e relax totale su spiagge bianche incontaminate.",
      11: "Vivi l'iconica Opera House di Sydney, porti meravigliosi, spiagge mozzafiato e fauna unica. Esplora la vibrante cultura australiana.",
      12: "Fai trekking fino all'antica cittadella Inca in alto sulle Ande. Scopri la ricca storia, panorami mozzafiato sulle montagne e la vibrante cultura peruviana.",
      13: "Gita di un giorno alla scoperta dei romantici canali di Venezia. Visita la Basilica di San Marco, goditi un giro in gondola ed esplora le affascinanti calli di questa città unica.",
      14: "Tour di un giorno della splendida costa delle Cinque Terre. Cammina tra i colorati borghi arroccati sulle scogliere, gusta il pesce locale e ammira viste mozzafiato sul Mediterraneo.",
      15: "Gita di un giorno nella capitale del Rinascimento. Ammira il Duomo, esplora la Galleria degli Uffizi e attraversa l'iconico Ponte Vecchio scoprendo l'arte e la cultura toscana.",
    },
    loading: "Caricamento...",
  },
};
